/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendedReservationsSavingsSummaryRequest {
    getFixupPrototypeFunction() { return RecommendedReservationsSavingsSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<RecommendedReservationsSavingsSummaryRequest>): RecommendedReservationsSavingsSummaryRequest {
        let obj = Object.assign(new RecommendedReservationsSavingsSummaryRequest(), model);
        RecommendedReservationsSavingsSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendedReservationsSavingsSummaryRequest>): RecommendedReservationsSavingsSummaryRequest {
        if (!model) return null;
        return RecommendedReservationsSavingsSummaryRequest.newInstance(<RecommendedReservationsSavingsSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendedReservationsSavingsSummaryRequest) {
        if (!obj) return;

        models.RecommendedReservationsSavingsSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendedReservationsSavingsSummaryRequest): boolean {
        Object.setPrototypeOf(obj, RecommendedReservationsSavingsSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    tenant_ids: Array<string>;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    services: Array<models.CloudServiceName>;

    /**
     * Year, it can be OneYear or ThreeYears.
     */
    term: models.PaymentTerms;

    /**
     * Select a payment option, it can be No_Upfront, Partial_Upfront or All_Upfront.
     */
    payment_option: models.PaymentOptions;

}
